// 导出模块 

export default [
    {
        path: "/basics/v2/actReFlowAbstract", // 流程定义
        component: () => import("./components/flow/ActReFlowAbstract.vue"),
    },
    {
        path: "/basics/v2/actreflow", // 流程设计
        component: () => import("./components/flow/ActReFlow.vue"),
    },
    {
        path: "/basics/v2/projectActReFlow", // 项目流程
        component: () => import("./components/flow/ProjectActReFlow.vue"),
    },
    {
        path: "/basics/v2/approveCenter", // 审批中心
        component: () => import("./components/flow/Approve/ApproveCenter.vue"),
    },
    {
        path: "/approve/basics/v2/actReFlowAbstract", // 测试审批页
        approve: true,
        component: () => import("./components/flow/ActReFlowAbstract.vue"),
    },
    {
        path: "/basics/report/reportTemplate", // 报表模板
        component: () => import("./components/report/ReportTemplate.vue"),
    },
    {
        path: "/basics/report/projectReportTemplate", // 项目报表模板
        component: () => import("./components/report/ProjectReportTemplate.vue"),
    },
]
import ApprovePage from './components/flow/Approve/ApprovePage.vue';
export { 
    ApprovePage
}